import axios from 'axios';

// Debug: Log the environment variable
console.log('REACT_APP_API_BASE_URL:', process.env.REACT_APP_API_BASE_URL);
console.log('Current window location:', window.location.href);

// Determine the base URL based on environment
let baseURL;
const isLocalhost = (host) => host === 'localhost' || host === '127.0.0.1';
const isIpAddress = (host) => /^(\d{1,3}\.){3}\d{1,3}$/.test(host);

if (isLocalhost(window.location.hostname)) {
  // Local development - use localhost backend
  baseURL = 'http://localhost:3000';
} else {
  const configured = process.env.REACT_APP_API_BASE_URL;
  try {
    const configuredHost = configured ? new URL(configured).hostname : null;
    const sameHost = configuredHost && configuredHost === window.location.hostname;
    // If accessed via IP or a host different from configured domain, use same-origin to avoid cross-origin/token/env mismatches
    if (isIpAddress(window.location.hostname) || !sameHost) {
      baseURL = window.location.origin;
    } else if (configured) {
      baseURL = configured;
    } else {
      baseURL = window.location.origin;
    }
  } catch {
    baseURL = window.location.origin;
  }
}

// Create axios instance with base URL
const api = axios.create({
  baseURL: baseURL,
  timeout: 10000,
});

// Debug: Log the final base URL
console.log('API Base URL:', api.defaults.baseURL);

// Add request interceptor to include auth token and cache-busting
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('app_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Add cache-busting timestamp to prevent caching issues
    if (config.method === 'get') {
      config.params = {
        ...config.params,
        _t: Date.now()
      };
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export default api;